import { LayoutTypes } from '../../../../../../components/DailyAgenda/viewModel/agendaViewModel/agendaViewModel';
import { AgendaItemListLayout } from './AgendaItemListLayout/AgendaItemListLayout';
import { AgendaItemSideBySideLayout } from './AgendaItemSideBySideLayout/AgendaItemSideBySideLayout';
import { AgendaItemOverlayLayout } from './AgendaItemOverlayLayout/AgendaItemOverlayLayout';
import { AgendaItemLayoutProps } from './const';

export const agendaItemLayoutFactory: {
  [key in LayoutTypes]: React.FC<AgendaItemLayoutProps>;
} = {
  [LayoutTypes.LIST]: AgendaItemListLayout,
  [LayoutTypes.SIDE_BY_SIDE]: AgendaItemSideBySideLayout, // Placeholder for card layout
  [LayoutTypes.OVERLAY]: AgendaItemOverlayLayout, // Placeholder for calendar layout
};
